/**
 * Checks if a value is empty (null, undefined, or empty string).
 * Useful for checking string/number values that may be empty.
 */
export const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === "string") {
    return value.trim() === "";
  }
  return false;
};
